import React, { Suspense } from 'react';
import { useTexture } from '@react-three/drei';
import * as THREE from 'three';
import { ROOMS } from '../rooms';

// RoomDecals — a brand's mark on a room's wall (2026-10-31).
//
// The GangstaFuel Gym's logo behind the fuel bar and on its big wall, the
// HypeTunes logo behind the headquarters' front desk. A room built in code
// (scripts/make_gym.mjs, make_hq.mjs) leaves the wall clear and reports where;
// rooms.js `decals` says what goes there:
//
//   decals: [{ url, pos: [x, y, z], size: [w, h], rotY, glow? }]
//
// room space at the room's fit (`k`, like the booth's marks), the plane's +z
// turned INTO the room by rotY (city/facing). The image's own alpha cuts it out,
// so a logo on transparency reads as painted on, not as a sticker. `glow` lifts
// it in a dark room (the gym runs on neon).

function Decal({ d, k }) {
  const tex = useTexture(d.url);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.anisotropy = 4;
  const [w, h] = d.size;
  return (
    <mesh position={[d.pos[0] * k, d.pos[1] * k, d.pos[2] * k]} rotation={[0, d.rotY || 0, 0]} renderOrder={2}>
      <planeGeometry args={[w * k, h * k]} />
      <meshStandardMaterial
        map={tex} transparent alphaTest={0.02} depthWrite={false} roughness={0.7} metalness={0}
        emissive="#ffffff" emissiveMap={d.glow ? tex : null} emissiveIntensity={d.glow ? d.glow : 0}
        polygonOffset polygonOffsetFactor={-2}
      />
    </mesh>
  );
}

export default function RoomDecals({ roomId, k = 1 }) {
  const list = ROOMS[roomId]?.decals || [];
  if (!list.length) return null;
  return (
    <Suspense fallback={null}>
      {list.map((d, i) => (d?.url && d.pos && d.size ? <Decal key={`${d.url}:${i}`} d={d} k={k} /> : null))}
    </Suspense>
  );
}
